/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Urun_EslestirmeInputs */

const tr_faq_a_urun_eslestirme = /** @type {(inputs: Faq_A_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok sayfasında her pazaryerindeki ürünler barkod veya ürün adına göre merkezi kataloğunla eşlenir. Otomatik eşleştirme barkod üzerinden çalışır; barkod yoksa Manuel Eşleştirme sekmesinden kendin yapabilirsin. Eşleşen ürünlerin stok ve fiyat bilgileri tüm pazaryerlerinde senkronize tutulur.`)
};

const en_faq_a_urun_eslestirme = /** @type {(inputs: Faq_A_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products from each platform are linked to your central catalog by barcode or product name. Automatic linking uses the barcode. If there is no barcode you can link manually from the Manual tab. Linked products share synced stock and price data across all connected platforms.`)
};

const de_faq_a_urun_eslestirme = /** @type {(inputs: Faq_A_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte von jeder Plattform werden anhand von Barcode oder Produktname mit deinem zentralen Katalog verknüpft. Automatische Verknüpfung läuft über den Barcode. Ohne Barcode kannst du manuell verknüpfen. Verknüpfte Produkte teilen synchronisierte Bestands- und Preisdaten.`)
};

const ru_faq_a_urun_eslestirme = /** @type {(inputs: Faq_A_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары с каждой площадки привязываются к вашему центральному каталогу по штрихкоду или названию. Автоматическая привязка работает по штрихкоду. Без штрихкода можно сделать это вручную. Привязанные товары имеют общие данные об остатках и ценах.`)
};

/**
* | output |
* | --- |
* | "Products from each platform are linked to your central catalog by barcode or product name. Automatic linking uses the barcode. If there is no barcode you can..." |
*
* @param {Faq_A_Urun_EslestirmeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_urun_eslestirme = /** @type {((inputs?: Faq_A_Urun_EslestirmeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Urun_EslestirmeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_urun_eslestirme(inputs)
	if (locale === "de") return de_faq_a_urun_eslestirme(inputs)
	if (locale === "ru") return ru_faq_a_urun_eslestirme(inputs)
	return tr_faq_a_urun_eslestirme(inputs)
});